import { render, staticRenderFns } from "./addvideo.vue?vue&type=template&id=9946a09a&scoped=true&"
import script from "./addvideo.vue?vue&type=script&lang=js&"
export * from "./addvideo.vue?vue&type=script&lang=js&"
import style0 from "./addvideo.vue?vue&type=style&index=0&id=9946a09a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9946a09a",
  null
  
)

export default component.exports